import { AxiosError, isAxiosError } from 'axios';

import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import { ArrowLeft16 } from '@ingrid/iconography/react';
import { AppError, Link } from '@ingrid/luterkort-react';

import { type LocalizationKey, useTranslation } from '~src/i18n/use-translation';
import { AppRoute } from '~src/main/routes';

import { AppExpiredPage } from './app-expired';

const errorMessages: Record<number, LocalizationKey> = {
  403: 'auth.forbidden',
  404: 'errors.pageNotFound',
};

export function AppErrorPage() {
  const { t } = useTranslation();
  const error = useRouteError();

  if (error instanceof AxiosError && error.response?.status === 401) {
    return <AppExpiredPage />;
  }

  const messageKey = isRouteErrorResponse(error)
    ? errorMessages[error.status]
    : isAxiosError(error) && error.response?.status
      ? errorMessages[error.response.status]
      : undefined;

  return (
    <AppError
      title={t('errors.title')}
      subtitle={t(messageKey ?? 'errors.unknown')}
      action={
        <Link href={AppRoute.ROOT} underline>
          <ArrowLeft16 />
          {t('common.goBack')}
        </Link>
      }
    />
  );
}
